export type TProjectName = string;

export type TProjectDescription = string;

export type TProjectMotivation = "Idea" | "Technology" | "Inspiration";

/**
 * AI-extracted step data structure
 * Each step contains field1, field2, etc. with values
 */
export type ExtractedStepData = Record<string, Record<string, string>>;

export interface ICreateAppData {
  projectName: TProjectName;
  projectDescription: TProjectDescription;
  projectMotivation: TProjectMotivation;
  useAI: boolean;
  aiExtractedData?: ExtractedStepData;
  aiAnalysisComplete?: boolean;
}

export const defaultCreateAppData: ICreateAppData = {
  projectName: "",
  projectDescription: "",
  projectMotivation: "Idea",
  useAI: true,
  aiExtractedData: undefined,
  aiAnalysisComplete: false,
};
